import React from 'react';
import fac from '../../../assets/facebook.svg';
import { useDispatch } from 'react-redux';
import { signInWithFacebook } from '../../../actions/user';
import FacebookLogin from 'react-facebook-login';
import { toastifyMessage } from '../../../handlers/toastifyMessage';
import { logOutFromFB } from "./logoutFromFacebook";

function SignInWithFacebook(props) {

    const dispatch = useDispatch();
    const responseFacebook = (response) => {
        if (response.email === undefined || !response.email) {
            props.setLoadingModalShow(false);
            toastifyMessage(`Login Failed.`, 'Authentication Error!', "error");
        }
        else {
            dispatch(signInWithFacebook(response.accessToken, props.history, props.setLoadingModalShow, props.fromState, props.completeInfo, props.lodaingSwitch, props.setWait));
        }
    };
    const onFailure = (error) => {
        props.setLoadingModalShow(false);
        toastifyMessage(`Login Failed: Pop-up closed by user!`, undefined, "error");
    };

    const authStatus = (status: false) => {
        // Use native JavaScript event listener
        const handleFBAsyncInit = () => {
            // Code using the FB object goes here.
            if (window.FB) {
                window.FB.getLoginStatus(function (response) {
                    if (response.status && response.status === 'unknown' || response.status === 'not_authorized') {
                        props.setLoadingModalShow(false);
                    }
                });
            }
        };

        // Check if FB is already loaded
        if (window.FB) {
            handleFBAsyncInit();
        } else {
            // Wait for FB SDK to load
            window.addEventListener('fbAsyncInit', handleFBAsyncInit, { once: true });
        }
    }


    return (
        <>
            <FacebookLogin
                appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                fields="name, email"
                scope="public_profile, email"
                cookie={true}
                autoLoad={false}
                xfbml={true}
                version="12.0"
                reAuthenticate
                authType="reauthenticate"
                disableMobileRedirect={true}
                onClick={() => {
                    authStatus();
                    logOutFromFB();
                    props.setLoadingModalShow(true);
                }}
                textButton=''
                cssClass='login_sign_social_logos'
                buttonStyle={{ border: 'none', backgroundColor: 'transparent' }
                }
                icon={<img src={fac} alt='facebook_logo' className='login_sign_social_logos' />}
                callback={responseFacebook}
                onFailure={onFailure}
            />
        </>
    );
};

export default SignInWithFacebook;